import { PageController } from '@client/components/_core/layout/PageController';
import { PaymentOverlay } from '@client/components/claims/financials/payment-approval/PaymentOverlay';
import { ENABLE_CLAIM_PAYMENT_APPROVAL_FLAG } from '@shared/constants';
import { createFileRoute, notFound } from '@tanstack/react-router';

/**
 * CUR-2767 (requirement 7, AC5): a payment opened from the claim's Library, where a document it
 * supports is listed. The same Payment overlay as on the Financials tab, over the Library, so closing
 * it goes back to the Library.
 */
export const Route = createFileRoute('/console/$orgId/claims/details/$id/library/payments/$compensationId')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Payment',
        },
        // Hidden with the rest of payment approval; the server answers NOT_FOUND while it is off.
        featureFlag: ENABLE_CLAIM_PAYMENT_APPROVAL_FLAG,
    },
    params: {
        parse({ compensationId }) {
            // An edited link's non-numeric segment is a 404, not a BigInt SyntaxError.
            if (!/^[1-9]\d*$/.test(compensationId)) throw notFound();
            return {
                compensationId: BigInt(compensationId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { id: claimId, compensationId } = Route.useParams();
    return (
        <PageController route={Route}>
            <PaymentOverlay claimId={claimId} compensationId={compensationId} />
        </PageController>
    );
}
